import Axios from './axios.service';

let loggedCache = null;

async function login(credentials) {
  const { data } = await Axios.post('/login', credentials);
  loggedCache = true;
  return data;
}

async function logout() {
  await Axios.post('/logout', {}, { withCredentials: true });
  loggedCache = false;
}

  async function isLogged(force = false) {
    if (loggedCache !== null && !force) return loggedCache;
  
    try {
      await Axios.get('/me', { withCredentials: true });
      loggedCache = true;
    } catch {
      loggedCache = false;
    }
    return loggedCache;
  }
function isCachedLoggedIn() {
  return loggedCache === true;
}

export const accountService = {
  login,
  logout,
  isLogged,
  isCachedLoggedIn
};